/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { NumberFormatter } from './NumberFormatter.js';
/**
 * Signature of a value-formatter
 * * value - the value to be formatted
 * * locale - the locale to be used
 */

/**
 * Creates a {@link ValueFormat} for the given formatter-type.
 */
export function createValueFormat(shorthandLabels, decimalPlaces) {
  const numberFormatter = new NumberFormatter(shorthandLabels, decimalPlaces);
  return (value, locale) => numberFormatter.format(value, locale);
}
